module.exports = "/virtual-football-league/img/amblems/right/logos/Southampton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Southampton.png
// module id = 2229
// module chunks = 4